<template>
  <div class="report-item">
    <span class="label">{{label}}</span>
    <div class="data">
      <span class="value">{{value}}</span>
      <span class="unit">{{unit}}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.report-item {
  display: flex;
  align-items: baseline;
  padding: $spacing--xxs 0;
  &:hover {
    background-color: var(--background--secondary);
  }
}

.label {
  @extend %text-style--label;
  flex: 0 0 40%;
  color: var(--color--secondary);
  padding-right: $spacing--xs;
}

.unit {
  font-size: var(--text--s);
  color: var(--color--secondary);
}

</style>

<script>
export default {
  props: {
    label: String,
    value: [String, Number],
    unit: String
  }
}
</script>
